import React, { useState } from 'react';
import { FaInstagram, FaFacebook, FaWaze, FaWhatsapp, FaEnvelope, FaComment } from 'react-icons/fa';
function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      console.log('Sending form data:', formData);

      // שליחה ל-API
      const response = await fetch('https://www-hzh6.vercel.app/backend/api.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'contact',
          ...formData
        })
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      if (response.ok) {
        const result = await response.json();
        console.log('Response data:', result);

        // ננסה לפתוח WhatsApp בחלון חדש
        if (result.whatsapp_url) {
          console.log('Opening WhatsApp URL:', result.whatsapp_url);
          const whatsappWindow = window.open(result.whatsapp_url, '_blank');

          // אם החלון נחסם, נציג הודעה למשתמש
          setTimeout(() => {
            if (!whatsappWindow || whatsappWindow.closed) {
              setSubmitMessage('ההודעה נשלחה בהצלחה! אם WhatsApp לא נפתח, ');
              setWhatsappLink(result.whatsapp_url);
            } else {
              setSubmitMessage('ההודעה נשלחה בהצלחה! נחזור אליך בקרוב.');
            }
          }, 1000);
        } else {
          setSubmitMessage('ההודעה נשלחה בהצלחה! נחזור אליך בקרוב.');
        }

        // שמירת הלינק להצגה
        setWhatsappLink(result.whatsapp_url);

        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        // If API fails, still show success message for user experience
        console.log('API not available, simulating success');
        const whatsappNumber = '972522714455';
        const whatsappMessage = `הודעה מאתר בינה לבנייה:\n\nשם: ${formData.name}\nטלפון: ${formData.phone}${formData.email ? `\nאימייל: ${formData.email}` : ''}\n\nהודעה:\n${formData.message}`;
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

        const whatsappWindow = window.open(whatsappUrl, '_blank');
        setTimeout(() => {
          if (!whatsappWindow || whatsappWindow.closed) {
            setSubmitMessage('ההודעה נשלחה בהצלחה! אם WhatsApp לא נפתח, ');
            setWhatsappLink(whatsappUrl);
          } else {
            setSubmitMessage('ההודעה נשלחה בהצלחה! נחזור אליך בקרוב.');
          }
        }, 1000);

        setWhatsappLink(whatsappUrl);
        setFormData({ name: '', email: '', phone: '', message: '' });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setSubmitMessage('שגיאה בשליחת ההודעה. אנא נסה שוב או צור קשר בטלפון.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact">
      <div className="contact-header">
        <img src="/logo/logo.png" alt="לוגו בינה" className="contact-logo" />
        <h2>צור קשר</h2>
      </div>
      <p>אנו כאן לעזור לך להגשים את החלום שלך. צור קשר עוד היום!</p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="שם מלא"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="כתובת אימייל (אופציונלי)"
          value={formData.email}
          onChange={handleInputChange}
        />
        <input
          type="tel"
          name="phone"
          placeholder="מספר טלפון"
          value={formData.phone}
          onChange={handleInputChange}
          required
        />
        <textarea
          name="message"
          placeholder="הודעה"
          rows="5"
          value={formData.message}
          onChange={handleInputChange}
          required
        ></textarea>
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'שולח...' : 'שלח הודעה'} <FaEnvelope style={{ marginLeft: '8px' }} />
        </button>
      </form>
      {submitMessage && (
        <div style={{
          marginTop: '1rem',
          padding: '1rem',
          borderRadius: '8px',
          backgroundColor: submitMessage.includes('הצלחה') ? 'rgba(0, 212, 255, 0.1)' : 'rgba(255, 107, 107, 0.1)',
          border: `1px solid ${submitMessage.includes('הצלחה') ? '#00d4ff' : '#ff6b6b'}`,
          color: submitMessage.includes('הצלחה') ? '#00d4ff' : '#ff6b6b'
        }}>
          {submitMessage}
          {whatsappLink && (
            <span>
              לחץ על הלינק הבא כדי לפתוח WhatsApp:
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#00d4ff',
                  textDecoration: 'underline',
                  fontWeight: 'bold',
                  marginRight: '0.5rem',
                  marginLeft: '0.5rem'
                }}
              >
                פתח WhatsApp <FaComment style={{ marginLeft: '8px' }} />
              </a>
            </span>
          )}
        </div>
      )}
      {/* <div className="contact-info">
        <div className="info-item">
         <a style={{ textDecoration: 'none', color: 'inherit' }} href="https://waze.com/ul?q=עפולה,ישראל">
          <h3><FaWaze style={{marginLeft: '8px'}} /> כתובת</h3>
          <p>עפולה , ישראל</p>
        </a>
      </div>
      <div className="info-item">
        <a style={{ textDecoration: 'none', color: 'inherit' }} href="https://wa.me/972522714455">
          <h3><FaWhatsapp style={{marginLeft: '8px'}} /> טלפון</h3>
          <p>052-271-4455</p>
        </a>
      </div>
        <div className="info-item">
         <a style={{ textDecoration: 'none', color: 'inherit' }} href="mailto:Office@binalb.com">
            <h3><FaEnvelope style={{marginLeft: '8px'}} /> אימייל</h3>
            <p>Office@binalb.com</p>
            
          </a>
        </div>
      </div> */}
      <div className="contact-cta">
        <h3>מוכנים להתחיל?</h3>
        <p>צרו קשר עוד היום וקבלו ייעוץ חינם והצעת מחיר מותאמת אישית</p>
        <div className="social-links">
          <a href="https://www.facebook.com/profile.php?id=61582556271313" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaFacebook />
          </a>
          <a href="https://www.instagram.com/bina.bnia/" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaInstagram />
          </a>
          <a href="mailto:Office@binalb.com" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaEnvelope />
          </a>
          <a href="https://wa.me/972522714455" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaWhatsapp />
          </a>
          <a href="https://ul.waze.com/ul?place=ChIJ-zbFi8NTHBURSwqqD4dNEuM&ll=32.61049300%2C35.28792200&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaWaze />
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
